// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__OXN_r","text":"SelectPayment_text__2qoFZ","title":"SelectPayment_title__2jt6A","btn":"SelectPayment_btn__3KV6G"};